export const ROUTE_PRIVACY_POLICY = 'https://heavnn.io/privacy-policy'
export const ROUTE_COUNTRY_FROM_IP = 'https://ipapi.co/json'
export const ROUTE_LOGIN = '/login'
export const ROUTE_CREATE_ACCOUNT = '/create-account'
export const ROUTE_RECOVER_PASSWORD = '/recover-password'
export const ROUTE_COUNTRIES = '/countries'

export const ROUTE_ROOT = '/'
export const ROUTE_OVERVIEW = '/overview'
export const ROUTE_WHAT_S_NEXT = '/what-s-next'

export const ROUTE_NEW_SIMULATION_BUSINESS_REGISTRATION = '/new-simulation/business-registration'
export const ROUTE_NEW_SIMULATION_BUSINESS_REGISTRATION_ID = (simulationId: string) =>
  `${ROUTE_NEW_SIMULATION_BUSINESS_REGISTRATION}/${simulationId}`
export const ROUTE_BUSINESS_REGISTRATION_RESULT = (simulationId: string) =>
  `reports/business-registration/${simulationId}`
export const ROUTE_NEW_SIMULATION_HANDOVER = '/new-simulation/handover'
export const ROUTE_NEW_SIMULATION_HANDOVER_ID = (simulationId: string) =>
  `${ROUTE_NEW_SIMULATION_HANDOVER}/${simulationId}`
export const ROUTE_HANDOVER_REPORT = (simulationId: string) => `/reports/handover/${simulationId}`
export const ROUTE_NEW_SIMULATION_DYT = '/new-simulation/do-your-taxes'
export const ROUTE_NEW_SIMULATION_DYT_ID = (simulationId: string, step: number) =>
  `${ROUTE_NEW_SIMULATION_DYT}/${simulationId}?step=${step}`
export const ROUTE_DYT_REPORT = (simulationId: string) => `/reports/do-your-taxes/${simulationId}`
// export const ROUTE_EDIT_SIMULATION = (simulationId: string) => `/reports/${simulationId}/edit`
export const ROUTE_PROFILE = '/profile'
export const ROUTE_PAYMENT = (simulationId: string) => `/payment?simulationId=${simulationId}`
export const ROUTE_PRICING = '/our-pricing'

// Admin routes
export const ROUTE_ADMIN = '/admin'
export const ROUTE_ADMIN_USERS_RESULT = (userId: string) => `/admin/users/${userId}/simulations`
export const ROUTE_ADMIN_USERS_RESULT_REPORT = (userId: string, simulationId: string) =>
  `/admin/users/${userId}/simulations/${simulationId}/report`
export const ROUTE_ADMIN_USERS_RESULT_TODOS = (userId: string) => `/admin/users/${userId}/todos`

const allowedRoutesNoAuth = [
  ROUTE_LOGIN,
  ROUTE_CREATE_ACCOUNT,
  ROUTE_COUNTRIES,
  ROUTE_RECOVER_PASSWORD,
  '/pricing',
]

export const routeRequiresAuth = (pathname: string) => !allowedRoutesNoAuth.includes(pathname)

export const isRouteAdmin = (pathname: string) => pathname.includes('admin')
